/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { TabSwitcherProps } from "./TabSwitcherProps";

import "./TabSwitcher.scss";

const TabSwitcher: FunctionComponent<TabSwitcherProps> = (
  props: TabSwitcherProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store -- Required by CodingGuidelines §7 (D-09) for logging context
  const TAG: string = "TabSwitcher";
  const { tabs, activeTabId, onTabChange, isFocused } = props;

  return (
    <div className="tab-switcher">
      {tabs.map((tab) => {
        const isActive: boolean = tab.id === activeTabId;
        const isNavFocused: boolean = isActive && isFocused === true;
        return (
          <button
            key={tab.id}
            className={
              "tab-switcher__tab" +
              (isActive ? " tab-switcher__tab--active" : "") +
              (isNavFocused ? " tab-switcher__tab--nav-focused" : "")
            }
            type="button"
            tabIndex={0}
            onClick={(): void => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitcher;
